"use client";

import React, { useState } from "react";
import { ArrowDownRight, ArrowUpRight, Search, Filter as Funnel, Download, Ellipsis, Activity, Users, Package } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Table, TableHeader, TableBody, TableHead, TableRow, TableCell } from "@/components/ui/table";
import { Progress } from "@/components/ui/progress";
import { Button } from "@/components/ui/button";
const transacoes = [{
  id: "ORD-5501",
  data: "2024-05-24",
  descricao: "Pedido Atacado - Distribuidora Sul",
  categoria: "Venda ERP",
  valor: 12500.00,
  status: "Concluído"
}, {
  id: "ORD-5502",
  data: "2024-05-23",
  descricao: "Integração Marketplace PluggTo",
  categoria: "E-commerce",
  valor: 4500.00,
  status: "Concluído"
}, {
  id: "ORD-5503",
  data: "2024-05-21",
  descricao: "Frete Logística Express - WMS",
  categoria: "Logística",
  valor: -850.75,
  status: "Pendente"
}, {
  id: "ORD-5504",
  data: "2024-05-20",
  descricao: "Consultoria Implantação e-Millennium",
  categoria: "Serviços",
  valor: 3800.00,
  status: "Concluído"
}, {
  id: "ORD-5505",
  data: "2024-05-18",
  descricao: "Reposição de Estoque - Indústria",
  categoria: "Suprimentos",
  valor: -13200.00,
  status: "Concluído"
}, {
  id: "ORD-5506",
  data: "2024-05-15",
  descricao: "Taxa de Manutenção Cloud Linx",
  categoria: "Infraestrutura",
  valor: -650.00,
  status: "Processando"
}, {
  id: "ORD-5507",
  data: "2024-05-12",
  descricao: "Venda Omnichannel - Rede Franquias",
  categoria: "Venda ERP",
  valor: 28900.00,
  status: "Concluído"
}];
const fornecedores = [{
  id: "FOR-001",
  nome: "Linx Sistemas S.A.",
  contato: "Suporte Especialista",
  email: "suporte@linx.com.br",
  status: "Ativo",
  ultima_compra: "2024-05-15",
  gasto_total: 154000.00
}, {
  id: "FOR-002",
  nome: "Logística Rápida BR",
  contato: "Ricardo Mendes",
  email: "operacional@logbr.com.br",
  status: "Ativo",
  ultima_compra: "2024-05-21",
  gasto_total: 12500.50
}, {
  id: "FOR-003",
  nome: "AWS Cloud Services",
  contato: "Billing Team",
  email: "faturamento@aws.com",
  status: "Ativo",
  ultima_compra: "2024-05-05",
  gasto_total: 8900.00
}, {
  id: "FOR-004",
  nome: "PluggTo Hub S.A.",
  contato: "Ana Costa",
  email: "comercial@pluggto.com.br",
  status: "Ativo",
  ultima_compra: "2024-05-10",
  gasto_total: 4500.00
}, {
  id: "FOR-005",
  nome: "Consultoria Tributária",
  contato: "Dr. Roberto",
  email: "fiscal@consultoria.com.br",
  status: "Pendente",
  ultima_compra: "2024-04-28",
  gasto_total: 3200.00
}];
const inventario = [{
  id: "SKU-ERP-ENT",
  produto: "Licença e-Millennium Enterprise",
  sku: "ERP-MLN-ENT",
  categoria: "Software",
  preco: 15000.00,
  stock_atual: 8,
  stock_maximo: 50
}, {
  id: "SKU-COL-ZEB",
  produto: "Coletor de Dados Zebra WMS",
  sku: "WMS-COL-ZEB",
  categoria: "Hardware",
  preco: 2850.00,
  stock_atual: 42,
  stock_maximo: 100
}, {
  id: "SKU-PDV-TCH",
  produto: "Terminal PDV Touchscreen Seta",
  sku: "PDV-TCH-SET",
  categoria: "Hardware",
  preco: 3200.00,
  stock_atual: 3,
  stock_maximo: 20
}, {
  id: "SKU-LIC-MVX",
  produto: "Licença Microvix POS Cloud",
  sku: "MVX-POS-CLD",
  categoria: "Software",
  preco: 450.00,
  stock_atual: 28,
  stock_maximo: 30
}, {
  id: "SKU-IMP-TER",
  produto: "Impressora Térmica Fiscal",
  sku: "IMP-TER-FIS",
  categoria: "Hardware",
  preco: 1120.00,
  stock_atual: 5,
  stock_maximo: 40
}, {
  id: "SKU-SRV-CLD",
  produto: "Instância Servidor Cloud Dedicated",
  sku: "SRV-CLD-DED",
  categoria: "Infraestrutura",
  preco: 1800.00,
  stock_atual: 15,
  stock_maximo: 50
}];
const formatCurrency = (value: number) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value);
};
const getStatusColor = (status: string) => {
  switch (status.toLowerCase()) {
    case 'concluído':
    case 'ativo':
      return 'bg-primary/10 text-primary border-primary/20';
    case 'pendente':
    case 'processando':
      return 'bg-yellow-500/10 text-yellow-500 border-yellow-500/20';
    case 'inativo':
      return 'bg-destructive/10 text-destructive border-destructive/20';
    default:
      return 'bg-muted text-muted-foreground border-border';
  }
};
export default function EcossistemaDeTabelas() {
  const [activeTab, setActiveTab] = useState("transacoes");
  return <section data-section-id="76813" id="poder-operacional-e-escala" className="bg-background/70 backdrop-blur-xl text-foreground py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/5 rounded-full blur-[120px] pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-[30rem] h-[30rem] bg-accent/5 rounded-full blur-[150px] pointer-events-none" />

      <div className="max-w-7xl mx-auto relative z-10">
        
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-3 text-foreground">
              Poder Operacional e Escala
            </h2>
            <p className="text-muted-foreground max-w-2xl text-lg">
              Gestão centralizada de alta densidade para atacado e indústria. Acompanhe pedidos, parceiros logísticos e níveis de estoque WMS em tempo real com precisão absoluta.
            </p>
          </div>
          
          <div className="flex items-center gap-3">
            
            
          </div>
        </div>

        <div className="bg-card/70 backdrop-blur-xl border border-border rounded-[12px] shadow-2xl overflow-hidden flex flex-col">
          
          <Tabs defaultValue="transacoes" value={activeTab} onValueChange={setActiveTab} className="w-full flex flex-col h-full">
            
            <div className="p-4 md:p-6 border-b border-border bg-muted/30 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
              <TabsList className="bg-background/50 border border-border p-1 rounded-[10px]">
                <TabsTrigger value="transacoes" className="rounded-[8px] data-[state=active]:bg-primary/20 data-[state=active]:text-primary data-[state=active]:border-primary/30">
                  <Activity className="w-4 h-4 mr-2" />
                  Operações
                </TabsTrigger>
                <TabsTrigger value="fornecedores" className="rounded-[8px] data-[state=active]:bg-primary/20 data-[state=active]:text-primary data-[state=active]:border-primary/30">
                  <Users className="w-4 h-4 mr-2" />
                  Logística
                </TabsTrigger>
                <TabsTrigger value="inventario" className="rounded-[8px] data-[state=active]:bg-primary/20 data-[state=active]:text-primary data-[state=active]:border-primary/30">
                  <Package className="w-4 h-4 mr-2" />
                  Estoque WMS
                </TabsTrigger>
              </TabsList>

              <div className="relative w-full sm:w-64">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
                <input type="text" placeholder="Pesquisar registros..." className="w-full bg-background/50 border border-border rounded-[10px] pl-9 pr-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary/50 transition-all placeholder:text-muted-foreground text-foreground" />
              </div>
            </div>

            <div className="flex-1 overflow-hidden">
              
              <TabsContent value="transacoes" className="m-0 h-full data-[state=active]:flex flex-col">
                <div className="max-h-[600px] overflow-y-auto scrollbar-thin scrollbar-thumb-border scrollbar-track-transparent">
                  <Table>
                    <TableHeader>
                      <TableRow className="hover:bg-transparent border-border">
                        <TableHead className="sticky top-0 bg-card/95 backdrop-blur-md z-10 w-[120px] text-foreground font-semibold">ID PEDIDO</TableHead>
                        <TableHead className="sticky top-0 bg-card/95 backdrop-blur-md z-10 text-foreground font-semibold">Data</TableHead>
                        <TableHead className="sticky top-0 bg-card/95 backdrop-blur-md z-10 min-w-[250px] text-foreground font-semibold">Descrição da Operação</TableHead>
                        <TableHead className="sticky top-0 bg-card/95 backdrop-blur-md z-10 text-foreground font-semibold">Categoria</TableHead>
                        <TableHead className="sticky top-0 bg-card/95 backdrop-blur-md z-10 text-right text-foreground font-semibold">Valor Bruto</TableHead>
                        <TableHead className="sticky top-0 bg-card/95 backdrop-blur-md z-10 text-center text-foreground font-semibold">Status</TableHead>
                        <TableHead className="sticky top-0 bg-card/95 backdrop-blur-md z-10 w-[50px]"></TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {transacoes.map((trx, i) => <TableRow key={trx.id} data-index={i} className="border-border even:bg-muted/10 odd:bg-transparent hover:bg-accent/10 transition-colors">
                          <TableCell className="font-mono text-xs text-muted-foreground">{trx.id}</TableCell>
                          <TableCell className="font-mono text-sm">{trx.data}</TableCell>
                          <TableCell className="font-medium text-foreground">{trx.descricao}</TableCell>
                          <TableCell className="text-muted-foreground">{trx.categoria}</TableCell>
                          <TableCell className={`font-mono text-right font-medium ${trx.valor > 0 ? 'text-primary' : 'text-foreground'}`}>
                            <div className="flex items-center justify-end gap-1">
                              {trx.valor > 0 ? <ArrowUpRight className="w-3 h-3 text-primary" /> : <ArrowDownRight className="w-3 h-3 text-muted-foreground" />}
                              {formatCurrency(Math.abs(trx.valor))}
                            </div>
                          </TableCell>
                          <TableCell className="text-center">
                            <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${getStatusColor(trx.status)}`}>
                              {trx.status}
                            </span>
                          </TableCell>
                          <TableCell>
                            <Button variant="ghost" size="icon" className="h-8 w-8 text-muted-foreground hover:text-primary">
                              <Ellipsis className="w-4 h-4" />
                            </Button>
                          </TableCell>
                        </TableRow>)}
                    </TableBody>
                  </Table>
                </div>
              </TabsContent>

              <TabsContent value="fornecedores" className="m-0 h-full data-[state=active]:flex flex-col">
                <div className="max-h-[600px] overflow-y-auto scrollbar-thin scrollbar-thumb-border scrollbar-track-transparent">
                  <Table>
                    <TableHeader>
                      <TableRow className="hover:bg-transparent border-border">
                        <TableHead className="sticky top-0 bg-card/95 backdrop-blur-md z-10 w-[120px] text-foreground font-semibold">ID PARCEIRO</TableHead>
                        <TableHead className="sticky top-0 bg-card/95 backdrop-blur-md z-10 min-w-[200px] text-foreground font-semibold">Nome / Razão Social</TableHead>
                        <TableHead className="sticky top-0 bg-card/95 backdrop-blur-md z-10 text-foreground font-semibold">Contato Direto</TableHead>
                        <TableHead className="sticky top-0 bg-card/95 backdrop-blur-md z-10 text-foreground font-semibold">Email Corporativo</TableHead>
                        <TableHead className="sticky top-0 bg-card/95 backdrop-blur-md z-10 text-right text-foreground font-semibold">Volume Transacionado</TableHead>
                        <TableHead className="sticky top-0 bg-card/95 backdrop-blur-md z-10 text-center text-foreground font-semibold">Status</TableHead>
                        <TableHead className="sticky top-0 bg-card/95 backdrop-blur-md z-10 w-[50px]"></TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {fornecedores.map((forn, i) => <TableRow key={forn.id} data-index={i} className="border-border even:bg-muted/10 odd:bg-transparent hover:bg-accent/10 transition-colors">
                          <TableCell className="font-mono text-xs text-muted-foreground">{forn.id}</TableCell>
                          <TableCell className="font-medium text-foreground">{forn.nome}</TableCell>
                          <TableCell className="text-muted-foreground">{forn.contato}</TableCell>
                          <TableCell className="text-muted-foreground">{forn.email}</TableCell>
                          <TableCell className="font-mono text-right">{formatCurrency(forn.gasto_total)}</TableCell>
                          <TableCell className="text-center">
                            <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${getStatusColor(forn.status)}`}>
                              {forn.status}
                            </span>
                          </TableCell>
                          <TableCell>
                            <Button variant="ghost" size="icon" className="h-8 w-8 text-muted-foreground hover:text-primary">
                              <Ellipsis className="w-4 h-4" />
                            </Button>
                          </TableCell>
                        </TableRow>)}
                    </TableBody>
                  </Table>
                </div>
              </TabsContent>

              <TabsContent value="inventario" className="m-0 h-full data-[state=active]:flex flex-col">
                <div className="max-h-[600px] overflow-y-auto scrollbar-thin scrollbar-thumb-border scrollbar-track-transparent">
                  <Table>
                    <TableHeader>
                      <TableRow className="hover:bg-transparent border-border">
                        <TableHead className="sticky top-0 bg-card/95 backdrop-blur-md z-10 w-[120px] text-foreground font-semibold">SKU / TAG</TableHead>
                        <TableHead className="sticky top-0 bg-card/95 backdrop-blur-md z-10 min-w-[250px] text-foreground font-semibold">Ativo / Produto</TableHead>
                        <TableHead className="sticky top-0 bg-card/95 backdrop-blur-md z-10 text-foreground font-semibold">Categoria WMS</TableHead>
                        <TableHead className="sticky top-0 bg-card/95 backdrop-blur-md z-10 text-right text-foreground font-semibold">Vlr. Unitário</TableHead>
                        <TableHead className="sticky top-0 bg-card/95 backdrop-blur-md z-10 text-right w-[100px] text-foreground font-semibold">Qtd</TableHead>
                        <TableHead className="sticky top-0 bg-card/95 backdrop-blur-md z-10 min-w-[200px] text-foreground font-semibold">Nível de Disponibilidade</TableHead>
                        <TableHead className="sticky top-0 bg-card/95 backdrop-blur-md z-10 w-[50px]"></TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {inventario.map((item, i) => {
                      const stockPercentage = item.stock_atual / item.stock_maximo * 100;
                      const isLowStock = stockPercentage < 25;
                      return <TableRow key={item.id} data-index={i} className="border-border even:bg-muted/10 odd:bg-transparent hover:bg-accent/10 transition-colors">
                            <TableCell className="font-mono text-xs text-muted-foreground">{item.sku}</TableCell>
                            <TableCell className="font-medium text-foreground">{item.produto}</TableCell>
                            <TableCell className="text-muted-foreground">{item.categoria}</TableCell>
                            <TableCell className="font-mono text-right">{formatCurrency(item.preco)}</TableCell>
                            <TableCell className="font-mono text-right">
                              <span className={isLowStock ? "text-destructive font-bold" : "text-foreground"}>
                                {item.stock_atual}
                              </span>
                              <span className="text-muted-foreground text-xs ml-1">/ {item.stock_maximo}</span>
                            </TableCell>
                            <TableCell>
                              <div className="flex items-center gap-3">
                                <Progress value={stockPercentage} className={`h-1.5 ${isLowStock ? '[&_[data-slot=progress-indicator]]:bg-destructive bg-destructive/20' : '[&_[data-slot=progress-indicator]]:bg-primary bg-primary/20'}`} />
                                <span className="font-mono text-xs text-muted-foreground w-9 text-right">
                                  {Math.round(stockPercentage)}%
                                </span>
                              </div>
                            </TableCell>
                            <TableCell>
                              <Button variant="ghost" size="icon" className="h-8 w-8 text-muted-foreground hover:text-primary">
                                <Ellipsis className="w-4 h-4" />
                              </Button>
                            </TableCell>
                          </TableRow>;
                    })}
                    </TableBody>
                  </Table>
                </div>
              </TabsContent>

            </div>
            
            <div className="p-4 border-t border-border bg-muted/30 flex justify-between items-center text-sm text-muted-foreground">
              <span>Mostrando fluxo operacional em tempo real</span>
              <span className="font-mono text-xs">Sincronizado: {new Date().toLocaleTimeString('pt-BR', {
                hour: '2-digit',
                minute: '2-digit'
              })}</span>
            </div>

          </Tabs>
        </div>
      </div>
    </section>;
}